import { compose, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import AddTip from '../components/AddTip';
import { setTippingBarbers } from '../../../../register/tipping/actions';
import { getById } from '../../../barbers/selector';
import { redirectToAppointmentTipping } from '../../../payment/actions';

export default compose(
  connect(
    (state, ownProps) => ({
      barber: getById(state, ownProps.appointment.barberId),
    }),
    { setTippingBarbers, redirectToAppointmentTipping }
  ),
  withState('submitting', 'setSubmitting', false),
  withHandlers({
    onClick: (props) => () => {
      let start = Promise.resolve(props.appointment);

      if (props.areChangesPending) {
        start = start.then(() => props.updateAppointment(null, true, false));
      }

      return start.then((appointment) => {
        props.setSubmitting(false);
        if (!appointment) return;

        props.setTippingBarbers([
          {
            id: props.appointment.barberId,
            firstName: props.barber.firstName,
            priceForTip: props.appointment.totalCost,
          },
        ]);
        props.redirectToAppointmentTipping(props.appointment.id);
      });
    },
  })
)(AddTip);
